import React from "react";
import { Sparkles } from "lucide-react";

/**
 * Small gold seal shown on Discover cards when the astral compatibility
 * (western + Balinese Pawukon, weighted 0.6/0.4) reaches >=80.
 *
 * Encourages users to fill their birth date so they unlock this extra
 * discovery layer. Hidden when no astral score is available (the partner
 * hasn't filled their birth_date, or current user hasn't either).
 */
const SintoniaBadge = ({ score, size = "md" }) => {
  if (score == null || score < 80) return null;
  const dim = size === "sm" ? "text-[10px] px-2 py-1" : "text-xs px-2.5 py-1.5";
  return (
    <span
      data-testid="sintonia-cosmica-badge"
      title={`Afinidade astral ${score}% — signo, ascendente e Pawukon balinês em sintonia.`}
      className={`inline-flex items-center gap-1 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/50 text-[#C5A880] uppercase tracking-wider font-semibold backdrop-blur-sm ${dim}`}
    >
      <Sparkles className="w-3 h-3" />
      Sintonia cósmica · {score}%
    </span>
  );
};

export default SintoniaBadge;
